module.exports = __webpack_public_path__ + "static/stars-398b6b8ee65aa277c9a024a7a67df564.png";